import React, {useEffect, useRef, useState} from "react";
import {Row} from "antd";
import {useLocation, useHistory} from "react-router-dom";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";

export const AvailableCouriers = () => {
    const location = useLocation();
    const history = useHistory();
    const [recall, setRecall] = useState(true);

    const getFiltersFromUrl = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            city: searchParams.get("city") || undefined,
            companyId: searchParams.get("companyId") || undefined,
            subcompanyId: searchParams.get("subcompanyId") || undefined,
            courierType: searchParams.get("courierType") || undefined,
            preferredCourierId: searchParams.get("preferredCourierId") || undefined,
            forceCourierId: searchParams.get("forceCourierId") || undefined,
            pool: searchParams.get("pool") || undefined,
            distance: parseInt(searchParams.get("distance")) || 0
        };
    };

    const getCurrentPageFromUrl = () => {
        const searchParams = new URLSearchParams(location.search);
        return parseInt(searchParams.get("page")) || 1;
    };

    const [currentPage, setCurrentPage] = useState(getCurrentPageFromUrl());
    const [filters, setFilters] = useState(getFiltersFromUrl());

    const updateUrlParams = (newFilters, newPage) => {
        const params = new URLSearchParams();

        Object.entries(newFilters || filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                params.set(key, value.toString());
            }
        });

        const pageToSet = newPage || currentPage;
        if (pageToSet > 1) {
            params.set("page", pageToSet.toString());
        }

        const newUrl = `${location.pathname}?${params.toString()}`;
        history.push(newUrl);
    };

    useEffect(() => {
        updateUrlParams(filters, currentPage);
    }, [filters, currentPage]);

    useEffect(() => {
        const urlFilters = getFiltersFromUrl();
        const urlPage = getCurrentPageFromUrl();

        setFilters(urlFilters);
        setCurrentPage(urlPage);
    }, []);

    const handlePageChange = newPage => {
        setCurrentPage(newPage);
    };

    const [loading, availableCouriers] = useFetch({
        fetchFn: stores.courierStore.listAvailableCouriers.bind(null, {
            subCompanyId: filters?.subcompanyId,
            courierType:
                filters?.courierType && filters?.courierType !== "all"
                    ? filters?.courierType
                    : undefined,
            pool: filters?.pool,
            distance: 100000,
            availableCouriersPage: true
        }),
        waitForResponse: true,
        condition: Boolean(filters?.subcompanyId) && Boolean(filters?.courierType),
        initialCall: Boolean(filters?.subcompanyId) && Boolean(filters?.courierType),
        dependencies: [recall, filters?.subcompanyId, filters?.courierType, filters?.pool]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                    data={availableCouriers || []}
                    dataLoading={loading}
                    recall={() => setRecall(!recall)}
                />
            </Row>
            <Row justify="end">
                <ActionButtons filters={filters} recall={() => setRecall(!recall)} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={availableCouriers || []}
                    dataCount={0}
                    currentPage={currentPage}
                    setCurrentPage={handlePageChange}
                />
            </Row>
        </div>
    );
};
